// @flow

import React from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'
import type { Node } from 'react'
import color from 'michelangelo/dist/Components/styles/color'
import Row from 'michelangelo/dist/WebComponents/Layout/Row'
import Column from 'michelangelo/dist/WebComponents/Layout/Column'

type LayoutProps = {
  header?: Node,
  body: Node,
  usePadding?: boolean,
  isVerticalImage: ?boolean
}
const Header: ReactComponentStyled<{}> = styled.div`
  width: 100%;
  text-align: center;
  background-color: ${color.white};
  justify-content: center;
  display: flex;
`
Header.displayName = 'Header'

const Body: ReactComponentStyled<{}> = styled.div`
  background-color: ${color.white};
`
const Container: ReactComponentStyled<{}> = styled.div`
  max-width: 1440px;
  display: ${(props) => props.hasimage ? 'block' : 'inherit'};
  flex: 1;
`
Body.displayName = 'Body'

function WebLinkLayout ({ header, body, usePadding, isVerticalImage }: LayoutProps) {
  const getHeader = () => {
    if (!header) {
      return null
    }
    return <Header>{header}</Header>
  }

  const getBody = () => {
    return <Body usePadding={usePadding}>{body}</Body>
  }

  const fullColumn = isVerticalImage === null || isVerticalImage === false ? 'is-12' : null
  const headerComponent = getHeader()
  const bodyComponent = getBody()
  return <Row classNames={['is-centered', 'is-marginless', 'is-desktop']}><Container hasimage={fullColumn}><Column classNames={[fullColumn, 'is-paddingless']}>{headerComponent}</Column><Column classNames={[fullColumn, 'is-paddingless']}>{bodyComponent}</Column></Container></Row>
}

export default WebLinkLayout
